const Paths = {
  home: '/',
  services: '/services',
  contact: '/contact',
  wild: '/*',
}

export default Paths